import { ResultModel } from './result-model';
import { PSSRUser } from './pssr-user';

export class PSSRUserList {
  Users: PSSRUser[] = [];
  ResultModel: ResultModel;
}
